import axios from '@utils/api/axios';
import { endpoints } from '../endpoints';
import { MilestoneToBeBilled } from './types/billing.type';
import { CreateBillingOrderRequest } from './types/create-billing.type';
import { ChoicesStatusMilestone } from '@/types/milestone.interface';
import { BillingOrderDetail } from './types/billing-order-detail.type';
import { ApproveBillingRequest, RejectBillingRequest } from './types/billing-request.type';

export interface MilestonesToBeBilledQueryParams {
  organizationId: string;
  month?: number;
  year?: number;
  status?: ChoicesStatusMilestone;
  search?: string;
}

export async function fetchMilestonesToBeBilled(filters: MilestonesToBeBilledQueryParams) {
  const response = await axios.get<MilestoneToBeBilled[]>(
    endpoints.billing.milestonesToBeBilledByOrg(),
    {
      params: { ...filters },
    }
  );
  return response.data;
}

export async function createBillingOrder(billingOrderPayload: CreateBillingOrderRequest) {
  const response = await axios.post(endpoints.billing.createBillingOrder, billingOrderPayload);
  return response.data;
}

export async function fetchBillingOrderById(orderId: string) {
  const response = await axios.get<BillingOrderDetail>(
    endpoints.billing.getBillingOrderById(orderId)
  );
  return response.data;
}

export async function rejectBillingRequest(
  requestId: string,
  rejectBillingRequestPayload: RejectBillingRequest
) {
  const response = await axios.patch(
    endpoints.billing.rejectBillingOrder(requestId),
    rejectBillingRequestPayload
  );
  return response.data;
}

export async function approveBillingRequest(
  requestId: string,
  approveBillingRequestPayload: ApproveBillingRequest
) {
  const response = await axios.patch(
    endpoints.billing.approveBillingOrder(requestId),
    approveBillingRequestPayload
  );
  return response.data;
}
